import { useCallback, useEffect, useState } from 'react';
import { usePortalCmsRefresh } from '../../context/RealtimeSyncContext';

const API = process.env.REACT_APP_API_BASE_URL;

const LAYOUT_PORTAL_SLUGS = ['portal-sidebar', 'portal-header'];

export const useLayoutPortal = () => {
  const [sidebar, setSidebar] = useState(null);
  const [header, setHeader] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [sidebarRes, headerRes] = await Promise.all([
        fetch(`${API}/api/portal-cms/page/portal-sidebar`),
        fetch(`${API}/api/portal-cms/page/portal-header`),
      ]);
      const sidebarData = sidebarRes.ok ? (await sidebarRes.json()).data : null;
      const headerData = headerRes.ok ? (await headerRes.json()).data : null;
      setSidebar(sidebarData);
      setHeader(headerData);
    } catch {
      setSidebar(null);
      setHeader(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  usePortalCmsRefresh(LAYOUT_PORTAL_SLUGS, load);

  return { sidebar, header, loading, refresh: load };
};
